import { render, staticRenderFns } from "./UsersTable.vue?vue&type=template&id=2f18845c&scoped=true"
import script from "./index.js?vue&type=script&lang=js&external"
export * from "./index.js?vue&type=script&lang=js&external"
import style0 from "./UsersTable.vue?vue&type=style&index=0&id=2f18845c&prod&scoped=true&lang=scss"
import style1 from "./UsersTable.vue?vue&type=style&index=1&id=2f18845c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f18845c",
  null
  
)

export default component.exports